export default function WhatsAppFloat() {
  return (
    <a
      href="https://wa.me/552737236099"
      target="_blank"
      rel="noopener noreferrer nofollow"
      className="fixed bottom-5 right-5 z-50 w-14 h-14 bg-accent-500 hover:bg-accent-600 rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105"
      aria-label="Falar no WhatsApp"
    >
      <div className="w-7 h-7 flex items-center justify-center">
        <i className="ri-whatsapp-line text-background-50 text-2xl" />
      </div>
    </a>
  );
}